<template>
  <div v-if="show" class="ap-overlay" @click.self="$emit('close')">
    <div class="ap-modal">
      <div class="ap-scrollbar-cap is-top"></div>
      <div class="ap-scrollbar-cap is-bottom"></div>
      <div class="ap-modal-scroll">

        <div class="ap-modal-head">
          <h5 class="ap-modal-title">Select Input Options</h5>
          <button class="ap-modal-close" @click="$emit('close')">
            <fa-icon :icon="['fas', 'times']" />
          </button>
        </div>

        <!-- IRB Branch -->
        <div class="ap-opts-section">
          <div class="ap-opts-section-head">
            <fa-icon :icon="['fas', 'landmark']" class="ap-opts-section-icon" />
            <span>IRB Branch</span>
          </div>
          <div class="ap-opts-list">
            <div v-for="(item, i) in localBranches" :key="i" class="ap-opts-item">
              <span class="ap-opts-item-label">{{ item }}</span>
              <button type="button" class="ap-opts-item-remove" @click="localBranches.splice(i, 1)">
                <fa-icon :icon="['fas', 'times']" />
              </button>
            </div>
            <div v-if="!localBranches.length" class="ap-opts-empty">No options yet.</div>
          </div>
          <div class="ap-opts-add-row">
            <input
              v-model="newBranch"
              class="ap-opts-add-input"
              placeholder="Add branch…"
              @keydown.enter.prevent="addBranch"
            />
            <button type="button" class="ap-btn ap-btn-ghost ap-opts-add-btn" @click="addBranch">
              <fa-icon :icon="['fas', 'plus']" /> Add
            </button>
          </div>
        </div>

        <!-- Auditor -->
        <div class="ap-opts-section">
          <div class="ap-opts-section-head">
            <fa-icon :icon="['fas', 'user-tie']" class="ap-opts-section-icon" />
            <span>Auditor</span>
          </div>
          <div class="ap-opts-list">
            <div v-for="(item, i) in localAuditors" :key="i" class="ap-opts-item">
              <span class="ap-opts-item-label">{{ item }}</span>
              <button type="button" class="ap-opts-item-remove" @click="localAuditors.splice(i, 1)">
                <fa-icon :icon="['fas', 'times']" />
              </button>
            </div>
            <div v-if="!localAuditors.length" class="ap-opts-empty">No options yet.</div>
          </div>
          <div class="ap-opts-add-row">
            <input
              v-model="newAuditor"
              class="ap-opts-add-input"
              placeholder="Add auditor…"
              @keydown.enter.prevent="addAuditor"
            />
            <button type="button" class="ap-btn ap-btn-ghost ap-opts-add-btn" @click="addAuditor">
              <fa-icon :icon="['fas', 'plus']" /> Add
            </button>
          </div>
        </div>

        <!-- Contact Category -->
        <div class="ap-opts-section">
          <div class="ap-opts-section-head">
            <fa-icon :icon="['fas', 'tags']" class="ap-opts-section-icon" />
            <span>Contact Category</span>
          </div>
          <div class="ap-opts-list">
            <div v-for="(item, i) in localCategories" :key="i" class="ap-opts-item">
              <span class="ap-opts-item-label">{{ item }}</span>
              <button type="button" class="ap-opts-item-remove" @click="localCategories.splice(i, 1)">
                <fa-icon :icon="['fas', 'times']" />
              </button>
            </div>
            <div v-if="!localCategories.length" class="ap-opts-empty">No options yet.</div>
          </div>
          <div class="ap-opts-add-row">
            <input
              v-model="newCategory"
              class="ap-opts-add-input"
              placeholder="Add category…"
              @keydown.enter.prevent="addCategory"
            />
            <button type="button" class="ap-btn ap-btn-ghost ap-opts-add-btn" @click="addCategory">
              <fa-icon :icon="['fas', 'plus']" /> Add
            </button>
          </div>
        </div>

        <!-- Contact Title -->
        <div class="ap-opts-section">
          <div class="ap-opts-section-head">
            <fa-icon :icon="['fas', 'id-badge']" class="ap-opts-section-icon" />
            <span>Contact Title</span>
          </div>
          <div class="ap-opts-list">
            <div v-for="(item, i) in localTitles" :key="i" class="ap-opts-item">
              <span class="ap-opts-item-label">{{ item }}</span>
              <button type="button" class="ap-opts-item-remove" @click="localTitles.splice(i, 1)">
                <fa-icon :icon="['fas', 'times']" />
              </button>
            </div>
            <div v-if="!localTitles.length" class="ap-opts-empty">No options yet.</div>
          </div>
          <div class="ap-opts-add-row">
            <input
              v-model="newTitle"
              class="ap-opts-add-input"
              placeholder="Add title…"
              @keydown.enter.prevent="addTitle"
            />
            <button type="button" class="ap-btn ap-btn-ghost ap-opts-add-btn" @click="addTitle">
              <fa-icon :icon="['fas', 'plus']" /> Add
            </button>
          </div>
        </div>

      </div>

      <div class="ap-modal-footer">
        <button class="ap-btn ap-btn-ghost" @click="$emit('close')">Cancel</button>
        <button class="ap-btn ap-btn-primary" @click="save">Save</button>
      </div>

    </div>
  </div>
</template>

<script>
import bodyScrollLockMixin from '@/mixins/bodyScrollLockMixin'

export default {
  name: 'AdminOptionsModal',
  mixins: [bodyScrollLockMixin],
  props: {
    show: { type: Boolean, default: false },
    branches: { type: Array, default: () => [] },
    auditors: { type: Array, default: () => [] },
    categories: { type: Array, default: () => [] },
    titles: { type: Array, default: () => [] }
  },
  data () {
    return {
      localBranches: [],
      localAuditors: [],
      localCategories: [],
      localTitles: [],
      newBranch: '',
      newAuditor: '',
      newCategory: '',
      newTitle: ''
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.localBranches = [...this.branches]
        this.localAuditors = [...this.auditors]
        this.localCategories = [...this.categories]
        this.localTitles = [...this.titles]
        this.newBranch = ''
        this.newAuditor = ''
        this.newCategory = ''
        this.newTitle = ''
      }
    }
  },
  methods: {
    addBranch () {
      const val = this.newBranch.trim()
      if (val && !this.localBranches.includes(val)) this.localBranches.push(val)
      this.newBranch = ''
    },
    addAuditor () {
      const val = this.newAuditor.trim()
      if (val && !this.localAuditors.includes(val)) this.localAuditors.push(val)
      this.newAuditor = ''
    },
    addCategory () {
      const val = this.newCategory.trim()
      if (val && !this.localCategories.includes(val)) this.localCategories.push(val)
      this.newCategory = ''
    },
    addTitle () {
      const val = this.newTitle.trim()
      if (val && !this.localTitles.includes(val)) this.localTitles.push(val)
      this.newTitle = ''
    },
    save () {
      this.$emit('save', {
        branches: [...this.localBranches],
        auditors: [...this.localAuditors],
        categories: [...this.localCategories],
        titles: [...this.localTitles]
      })
    }
  }
}
</script>
